import React from "react";
import "./side-drawer.styles.scss";
import Backdrop from "../backdrop/backdrop.component";
import NavigationContainer from "../navigation/navigation.component";
import { User } from "../../@types/user.interface";

interface IProps {
    user: User | null;
    menus: {
        link: string;
        logo: string;
        name: string;
    }[];
    active: boolean;
    sideDrawerHandler: (status: boolean) => void;
}

function SideDrawer({ user, menus, active, sideDrawerHandler }: IProps) {
    if (!user) active = false;

    return (
        <div className="container">
            <Backdrop
                className="fixed"
                show={active}
                clickHandler={sideDrawerHandler}
            />
            <div
                className="side-drawer"
                style={{
                    transform: active ? "translateX(0%)" : "translateX(-100%)",
                }}
            >
                <div className="side-drawer__title">
                    <h1>Quiz Online</h1>
                </div>
                <div className="side-drawer__username">
                    Welcome, <br />
                    {user !== null
                        ? user.name !== undefined
                            ? user.name
                            : user.initial
                        : ""}
                </div>
                <NavigationContainer
                    sideDrawerHandler={sideDrawerHandler}
                    menus={menus}
                />
            </div>
        </div>
    );
}

export default SideDrawer;
